import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  Button,
  ButtonsWrapper,
  Content,
  Message,
  StyledPopup,
  Title
} from './styled';
import Icon from '../../Icon';

const colorSet = {
  red: '#ff586d',
  blue: '#4264fd',
  gray: '#98918a'
};

export const Popup = ({
  isOpen,
  title,
  message,
  closeHandler,
  acceptButtonTitle,
  acceptButtonColor = 'blue',
  onAcceptHandlerClick,
  declineButtonTitle,
  onDeclineHandlerClick,
  declineButtonColor = 'gray',
  additionalButtonTitle,
  onAdditionalHandlerClick,
  additionalButtonColor,
  icon,
  children
}) => {
  return (
    <StyledPopup
      isOpen={isOpen}
      onRequestClose={closeHandler}
      modalId="popup"
      overlayClassName="modal__overlay--alert"
      contentClassName={cn(
        'modal__content--alert',
        'modal__content--alert-popup'
      )}
    >
      <div data-cy="popup-modal">
        <Content>
          {icon && (
            <Icon width={18} height={16} indent={false} IconComponent={icon} />
          )}
          {title && <Title data-cy="popup-title">{title}</Title>}
          {message && <Message data-cy="popup-message">{message}</Message>}
          {children}
        </Content>
        <ButtonsWrapper isColumn={additionalButtonTitle}>
          {declineButtonTitle && (
            <Button
              role="button"
              tabIndex={0}
              data-cy="popup-decline-button"
              onClick={onDeclineHandlerClick}
              onKeyPress={onDeclineHandlerClick}
              borderBottom={additionalButtonTitle}
              color={colorSet[declineButtonColor]}
              borderRight={acceptButtonTitle && !additionalButtonTitle}
            >
              {declineButtonTitle}
            </Button>
          )}
          <Button
            role="button"
            tabIndex={-1}
            data-cy="popup-accept-button"
            onClick={onAcceptHandlerClick}
            onKeyPress={onAcceptHandlerClick}
            color={colorSet[acceptButtonColor]}
            borderBottom={additionalButtonTitle}
          >
            {acceptButtonTitle}
          </Button>
          {additionalButtonTitle && (
            <Button
              role="button"
              tabIndex={0}
              onClick={onAdditionalHandlerClick}
              onKeyPress={onAdditionalHandlerClick}
              color={colorSet[additionalButtonColor]}
            >
              {additionalButtonTitle}
            </Button>
          )}
        </ButtonsWrapper>
      </div>
    </StyledPopup>
  );
};

Popup.displayName = `Popup`;

Popup.propTypes = {
  isOpen: PropTypes.bool,
  closeHandler: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  onAcceptHandlerClick: PropTypes.func,
  acceptButtonTitle: PropTypes.string,
  acceptButtonColor: PropTypes.string,
  declineButtonTitle: PropTypes.string,
  onDeclineHandlerClick: PropTypes.func,
  declineButtonColor: PropTypes.string,
  additionalButtonTitle: PropTypes.string,
  onAdditionalHandlerClick: PropTypes.func,
  additionalButtonColor: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
};
